import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CardSuspendFiltering } from './Pages';

export const CardSuspendRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CardSuspendFiltering} />
    </Fragment>
)